import React, { useEffect } from "react";
import { useFiling } from "../../../../contexts/FilingContext";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import SectionListItem from "./components/SectionListItem/SectionListItem";
import InlineInsertSection from "./components/InlineInsertSection";
import { FilingService } from "../../../../services/FilingService";

const FilingDetailSectionList: React.FC = () => {
  const { filing, setFiling } = useFiling();

  const onDragEnd = (result: any) => {
    if (!result.destination) return;
    if (result.source.index === result.destination.index) return; // No change in position
    handleDragEnd(result);
  };

  const handleDragEnd = async (result: any) => {
    if (!result.destination || !filing) return;
    const reorderedSections = [...filing.sections];
    const [movedItem] = reorderedSections.splice(result.source.index, 1);
    reorderedSections.splice(result.destination.index, 0, movedItem);

    // Update the index values
    const updatedSections = reorderedSections.map((q, index) => ({
      ...q,
      index,
    }));
    setFiling({
      ...filing,
      sections: updatedSections,
    });
    const sectionIds = updatedSections.map((s) => s._id!);
    await FilingService.reorderSections(filing._id, sectionIds);
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="sectionList">
        {(provided) => (
          <div
            className="flex flex-col gap-4"
            ref={provided.innerRef}
            // {...provided.droppableProps}
          >
            {filing?.sections
              .sort((a, b) => a.index - b.index)
              .flatMap((section, i, arr) => {
                const insertBefore = i === 0 ? "start" : section._id;
                const insertAfter = section._id;
                const items = [];

                // Insert before the first section
                if (i === 0) {
                  items.push(
                    <InlineInsertSection
                      key={`insert-before-${insertBefore}`}
                      filing={filing}
                      insertAfterId={null}
                    />,
                  );
                }

                // Section itself
                items.push(
                  <Draggable
                    key={section._id}
                    draggableId={section._id!}
                    index={i}
                  >
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps} // ✅ Required for drag to work
                      >
                        <SectionListItem
                          section={section}
                          filing={filing}
                          dragHandleProps={provided.dragHandleProps} // ✅ Drag only on icon
                        />
                      </div>
                    )}
                  </Draggable>,
                );

                // Insert after this section
                items.push(
                  <InlineInsertSection
                    key={`insert-after-${insertAfter}`}
                    filing={filing}
                    insertAfterId={section._id!}
                  />,
                );

                return items;
              })}

            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default FilingDetailSectionList;
